<template>
  <div id="app">
    <LoadingComponent />
    <div id="nav">
      <Header />
    </div>
    <router-view/>
    <Footer />
  </div>
</template>

<script>
import store from './store'
import Header from  './components/Header.vue'
import Footer from  './components/Footer.vue'
import LoadingComponent from '@/components/LoadingComponent.vue'
export default {
  components:{
    Header,
    Footer,
    LoadingComponent
  },
  created(){
    var date = new Date();
    var today_year = date.getFullYear();
    var today_month = date.getMonth()+1;
    var today_week = date.getDay();
    var today_day = date.getDate();
    var today_weekStr = [ "日", "月", "火", "水", "木", "金", "土" ][today_week] ;
    var today_dateStr =  today_year + '年' + today_month + '月' + today_day  + '日' + ' (' + today_weekStr + ')';
    var today_info = { 
                      today_date:date,
                      today_dateStr: today_dateStr,
                      today_year:today_year,
                      today_month:today_month,
                      today_week:today_week,
                      today_day:today_day,
                      today_weekStr:today_weekStr
                    }
    store.commit('setTodayInfo', today_info);
  }
}
</script>


<style>
#app {
  font-family:'M PLUS 1p', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#nav {
  background-color: #ECF3F1;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
